import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MaterialModule } from '../../../../../shared/material.module'
import { SharedModule } from '../../../../../shared/shared.module'
import { DispenserOrderPlacedComponent } from './dispenser-order-placed.component'
// TODO:Spartacus - // TODO:Spartacus - Class ModalModule has been removed and is no longer part of the public API. For more information, see the 5.0 migration guide.
import { CardModule, MediaModule, OutletModule } from '@spartacus/storefront'
//ModalModule
import { RouterModule } from '@angular/router'
import { UrlModule } from '@spartacus/core'
import { CustomCartSharedModule } from '../../../../../cart/cart-shared/custom-cart-shared.module'
import { DispenserOrderItemsListComponent } from '../dispenser-order-items-list/dispenser-order-items-list.component'
import { DispenserOrderItemsComponent } from '../dispenser-order-items/dispenser-order-items.component'

@NgModule({
  declarations: [DispenserOrderPlacedComponent, DispenserOrderItemsComponent, DispenserOrderItemsListComponent],
  exports: [DispenserOrderPlacedComponent, DispenserOrderItemsComponent, DispenserOrderItemsListComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    CardModule,
    CustomCartSharedModule,
    OutletModule,
    RouterModule,
    UrlModule,
    MediaModule
  ]
})
export class DispenserOrderPlacedModule {}
